module.exports = __webpack_public_path__ + "img/discord-dark.0bf63da2.svg";